import { Typography } from "antd";
const { Text } = Typography;

interface IStatusLabel {
  type: "success" | "warning" | "danger" | "secondary";
  content: string;
}

const StatusLabel = (props: IStatusLabel) => {
  const { type, content } = props;
  return <Text type={type}>{content}</Text>;
};

export default StatusLabel;
